
export const putMarker = (mapObj: maplibregl.Map, coordinates: [number, number]): maplibregl.Marker | undefined => {
    if(!mapObj || !coordinates) { return; }
    const newMarker = new window.geolonia.Marker();
    newMarker.setLngLat(coordinates).addTo(mapObj);

    return newMarker;
};
